// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goBackBtn{padding:0 1rem;position:fixed;right:1px;background:#0091ea;height:36px !important;line-height:36px !important;border-radius:0 !important;min-width:50px}.disabledTabs{width:100%;background:#ccc;z-index:5;position:absolute;opacity:0.5;height:100%;top:0;bottom:0}.tabsContainer{position:relative}\n", ""]);
// Exports
module.exports = exports;
